/* import __COLOCATED_TEMPLATE__ from './data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {}

const StandaloneIntercomMessengerDeployData = templateOnlyComponent<Args>();
export default StandaloneIntercomMessengerDeployData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::IntercomMessenger::Deploy::Data': typeof StandaloneIntercomMessengerDeployData;
    'standalone/intercom-messenger/deploy/data': typeof StandaloneIntercomMessengerDeployData;
  }
}
